var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-app-status-2426100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M17.5,2.1A15.4,15.4,0,1,1,2.1,17.5,15.4,15.4,0,0,1,17.5,2.1m0-2.1A17.5,17.5,0,1,0,35,17.5,17.506,17.506,0,0,0,17.5,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M138.9,240a1.392,1.392,0,0,0-1.33.98.329.329,0,0,0-.035.14l-3.833,13.65-4.007-9.012c-.018-.035-.035-.088-.053-.122a1.394,1.394,0,0,0-1.225-.735,1.434,1.434,0,0,0-1.155.595v.035l-2.415,3.57H121.4a1.4,1.4,0,0,0,0,2.8h4.2a1.434,1.434,0,0,0,1.155-.595v-.053l1.4-2.065,4.55,10.255c.018.035.035.088.053.122a1.392,1.392,0,0,0,1.89.56,1.416,1.416,0,0,0,.665-.822l3.78-13.475,1.96,5.075c.018.053.035.087.053.14a1.393,1.393,0,0,0,1.295.857h4.2a1.4,1.4,0,0,0,0-2.8h-3.237l-3.115-8.12c-.018-.053-.035-.088-.053-.14a1.423,1.423,0,0,0-1.3-.84Z",
    transform: "translate(-116.499 -232.998)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAnalytics);
export default __webpack_public_path__ + "static/media/sidebar-analytics.5735c220ba932dc4410bba2970c55bed.svg";
export { ForwardRef as ReactComponent };